var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162 100",
    style: {
      enableBackground: "new 0 0 162 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DC922B;}\n\t.st1{fill:#CE6227;}\n\t.st2{fill:#C21925;}\n\t.st3{fill:#DF9B31;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.4,81V79h-0.5l-0.6,1.3l-0.6-1.3h-0.5V81h0.4v-1.5l0.5,1.3h0.4l0.5-1.3V81H160.4L160.4,81z M157.2,81v-1.6 h0.6V79h-1.7v0.3h0.6V81H157.2L157.2,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103,89.3H59.2V10.7H103L103,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62,50c0-15.9,7.5-30.2,19.1-39.3C72.3,3.8,61.4,0,50.2,0c-27.6,0-50,22.4-50,50s22.4,50,50,50 c11.2,0,22.1-3.8,30.9-10.7C69.5,80.2,62,66,62,50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162,50c0,27.6-22.4,50-50,50c-11.2,0-22.1-3.8-30.9-10.7C92.7,80.2,100.2,66,100.2,50s-7.5-30.2-19.1-39.3 C89.9,3.8,100.8,0,112,0C139.6,0,162,22.4,162,50"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b8f366fa8e93d7f2dc520d1ccf44b4f0.svg";
export { ForwardRef as ReactComponent };